// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gj-3";
export var downloadButton = "_gj-4";
export var fileContainer = "_gj-9 _gj-7";
export var fileContainerBase = "_gj-7";
export var fileContainerBaseSm = "_gj-a _gj-7";
export var fileContainerFixedHeight = "_gj-8 _gj-7";
export var fileContainerFixedHeightSm = "_gj-c _gj-a _gj-7";
export var fileContainerSm = "_gj-b _gj-a _gj-7";
export var fileInfo = "_gj-5";
export var fileInfoWidthRestricted = "_gj-6";
export var fileType = "_gj-1";
export var fileTypeName = "_gj-2";
export var fileTypeSm = "_gj-d _gj-1";
export var image = "_gj-0";
export var link = "_gj-f";
export var overflowEllipsis = "_gj-e";